import React, { useEffect, useState } from 'react'
import { Button, DropdownItem } from 'reactstrap'
import toastr from 'toastr'
import { connect } from 'react-redux'

import { loginSuccess } from '../../store/actions'
import { fetchMisEmpresas, getServerMessage, seleccionarEmpresaActiva } from '../../helpers/empresaUsuarios'

const EmpresaSwitcher = ({ mode = 'sidebar', userId, empresaId, empresaNombre, loginSuccess }) => {
    const [empresas, setEmpresas] = useState([])
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        let mounted = true

        const loadEmpresas = async () => {
            try {
                const data = await fetchMisEmpresas()

                if (!mounted) {
                    return
                }

                setEmpresas(data)
            } catch (error) {
                if (!mounted) {
                    return
                }

                setEmpresas([])
            }
        }

        loadEmpresas()

        return () => {
            mounted = false
        }
    }, [])

    const _toggle = async () => {
        const nextValue = !isOpen
        setIsOpen(nextValue)

        if (!nextValue) {
            return
        }

        try {
            const data = await fetchMisEmpresas()
            setEmpresas(data)
        } catch (error) {
            toastr.error(getServerMessage(error, 'No pude cargar tus empresas.'))
        }
    }

    const _selectEmpresa = async (selectedEmpresaId) => {
        try {
            const response = await seleccionarEmpresaActiva({
                empresaId: selectedEmpresaId,
                onLoginSuccess: loginSuccess
            })

            if (!response.data?.success) {
                toastr.error(response.data?.message || 'No pude cambiar de empresa.')
                return
            }

            window.location.reload()
        } catch (error) {
            toastr.error(getServerMessage(error, 'No pude cambiar de empresa.'))
        }
    }

    if (!userId || empresas.length <= 1) {
        return null
    }

    if (mode === 'dropdown') {
        return (
            <React.Fragment>
                <DropdownItem header>Cambiar empresa</DropdownItem>
                {empresas.map((empresa) => (
                    <DropdownItem
                        key={empresa._id}
                        disabled={`${empresa._id}` === `${empresaId}`}
                        onClick={() => _selectEmpresa(empresa._id)}
                    >
                        {empresa.nombre}
                    </DropdownItem>
                ))}
                <div className="dropdown-divider"></div>
            </React.Fragment>
        )
    }

    return (
        <div className="site-menubar-company-switcher" style={{ padding: '0 15px 15px' }}>
            <div style={{ marginBottom: '10px', color: '#6c757d', fontSize: '12px', textTransform: 'uppercase' }}>
                Empresa activa
            </div>
            <div style={{ marginBottom: '10px', fontWeight: 600 }}>
                {empresaNombre}
            </div>
            <Button color="light" size="sm" block onClick={_toggle}>
                {isOpen ? 'Ocultar empresas' : 'Cambiar empresa'}
            </Button>

            {isOpen && (
                <div style={{ marginTop: '10px' }}>
                    {empresas.map((empresa) => (
                        <Button
                            key={empresa._id}
                            color={`${empresa._id}` === `${empresaId}` ? 'primary' : 'link'}
                            block
                            disabled={`${empresa._id}` === `${empresaId}`}
                            onClick={() => _selectEmpresa(empresa._id)}
                            style={{ textAlign: 'left' }}
                        >
                            {empresa.nombre}
                        </Button>
                    ))}
                </div>
            )}
        </div>
    )
}

const mapStateToProps = (state) => ({
    userId: state.Auth.profile?.user?._id || '',
    empresaId: state.Auth.profile?.empresa?._id || '',
    empresaNombre: state.Auth.profile?.empresa?.nombre || ''
})

export default connect(mapStateToProps, { loginSuccess })(EmpresaSwitcher)
